var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 247,
    viewBox: "0 0 213 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 20",
    y: 86.976,
    width: 157.339,
    height: 119.226,
    fill: "url(#paint0_linear_16_15)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 21",
    filter: "url(#filter0_i_16_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.793 86.976H112.785C112.196 4.8865 47.1016 3.11012 47.7093 86.976H20.5496C18.4767 -28.9553 135.756 -29.0287 137.793 86.976Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 6",
    filter: "url(#filter1_i_16_15)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 78.998,
    cy: 126.209,
    r: 15.7783,
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4",
    d: "M71.7412 140.838C74.8204 135.505 82.5184 135.505 85.5976 140.838L87.3983 143.957C90.4775 149.291 86.6285 155.957 80.4701 155.957H76.8687C70.7103 155.957 66.8613 149.291 69.9405 143.957L71.7412 140.838Z",
    fill: "#7D7D7D"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M113.178 167.229L138.903 215.504L200 69.7675",
    stroke: "#789EFF",
    strokeWidth: 27
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_16_15",
    x: 20.5225,
    y: 0,
    width: 124.271,
    height: 91.9761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_15"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_16_15",
    x: 63.2197,
    y: 110.43,
    width: 31.5565,
    height: 49.5269,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_15",
    x1: 78.6693,
    y1: 86.976,
    x2: 78.6693,
    y2: 206.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D5E274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0FF7E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon 2.dee01cb8468ba8f80ae103decbde1e06.svg";
export { ForwardRef as ReactComponent };